import Vue from 'vue'
import { formatDistanceToNow } from 'date-fns'

Vue.filter('formatTimeDistance', value => {

    if (!value) return 'None'

    return formatDistanceToNow(parseInt(value), { addSuffix: true })

})